import { cx } from '@/lib/cx';

import { STAGES, type RailPosition } from '../stages';
import styles from './ProgressRail.module.css';

/**
 * The five pipeline stages, with the candidate's position marked.
 *
 * A stopped candidate, held or rejected, has their furthest stage painted in the
 * colour of the stop rather than in green, so the rail says both how far they got and
 * that they are not moving.
 */
export function ProgressRail({ position }: { position: RailPosition }) {
  const { index, stopped } = position;

  return (
    <ol className={styles.rail}>
      {STAGES.map((stage, step) => {
        const done = step < index;
        const current = step === index;

        return (
          <li
            key={stage}
            className={cx(
              styles.step,
              done && styles.done,
              current && styles.current,
              current && stopped === 'hold' && styles.held,
              current && stopped === 'rejected' && styles.rejected,
            )}
            // The one the eye should land on, and the one a screen reader should be
            // told is where the record actually is.
            aria-current={current ? 'step' : undefined}
          >
            <span className={styles.marker} aria-hidden="true" />
            <span className={styles.label}>{stage}</span>
          </li>
        );
      })}
    </ol>
  );
}
